import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from 'antd';
import { CreditCardOutlined, DatabaseOutlined, HistoryOutlined, TeamOutlined, } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import PlanUsage from 'screens/DashboardScreen/pages/AccountPage/CreditInfo/TeamPlan/PlanUsage';
import { useEffect, useState } from 'react';
import { fetchTeamSubscriptions } from 'api/admin/teams-api';
import { useSession } from 'components/Authenticated';
import { BYTES_IN_GIGABYTE } from 'libs/utils';
import { getEditionSubscriptions, PLAN_KEY_BEEY_START, PRODUCT_BEEY } from 'api/model/subscription-plan';
import styles from '../style.module.less';
const TeamPlanAdmin = ({ teamId, storageStatistics, teamMembersNumber, hasUnlimitedStorage, }) => {
    const [subscriptions, setSubscriptions] = useState('loading');
    const { session } = useSession();
    const usedStorage = storageStatistics !== 'loading'
        ? (storageStatistics.storagePerCount.reduce((acc, cur) => acc + cur.bytes, 0) / BYTES_IN_GIGABYTE).toFixed(2) : 0;
    const activeSubscription = subscriptions !== 'loading' ? getEditionSubscriptions(subscriptions, PRODUCT_BEEY).find((sub) => sub.isActive) : undefined;
    const isSubscribed = activeSubscription !== undefined
        && activeSubscription.items[0].planKey !== PLAN_KEY_BEEY_START;
    const teamMembersLimit = activeSubscription !== undefined
        ? activeSubscription.items[0].planMetadata.teamMembersLimit
        : 0;
    const storageLimit = activeSubscription !== undefined
        ? activeSubscription.items[0].planMetadata.storageLimit
        : 0;
    useEffect(() => {
        const fetchSubscriptions = async () => {
            const subs = await fetchTeamSubscriptions(session.connection, teamId);
            if (subs.list.length > 0) {
                setSubscriptions(subs.list);
            }
        };
        void fetchSubscriptions();
    }, []);
    return (_jsxs(Card, { bordered: false, className: styles.card, style: { width: '100%' }, title: (_jsxs(_Fragment, { children: [_jsxs("h2", { children: [_jsx(CreditCardOutlined, {}), "\u00A0", txt('teamPlanUsage')] }), _jsxs("p", { children: [' ', txt('teamPlanUsageLeft'), ":"] })] })), children: [isSubscribed ? (_jsxs(_Fragment, { children: [_jsx(PlanUsage, { icon: _jsx(HistoryOutlined, {}), total: activeSubscription.items[0].creditInitialAmount, remaining: activeSubscription.items[0].creditRemainingAmount, unit: "min", decimal: false }), _jsx(PlanUsage, { icon: _jsx(TeamOutlined, {}), total: teamMembersLimit, remaining: teamMembersLimit - teamMembersNumber, unit: txt('fromUsers').toLowerCase(), decimal: false })] })) : null, hasUnlimitedStorage ? (_jsx("p", { style: { textAlign: 'center' }, children: txt('userHasUnlimitedStorage') })) : (_jsx(PlanUsage, { icon: _jsx(DatabaseOutlined, {}), total: storageLimit, remaining: storageLimit - Number(usedStorage), unit: "GB", decimal: true }))] }));
};
export default TeamPlanAdmin;
